// eslint-disable-next-line camelcase, no-undef
__webpack_public_path__ = process.env.ASSETS_URL
const { run } = require('./lib/browser')

run()
